<template><svg class="ico ico__tick" width="800" height="800" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Tick">
  <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3.7 14.3 9.6 19 20.3 5"/>
</svg>
</template>